import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import { getBanks, clearBanks } from '../../../../actions';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';

const BankSelect = ({
  dispatchGetBanks,
  dispatchClearBanks,
  banks,
  isLoading,
  isMulti,
  input,
  meta,
  ...rest
}) => {
  useLayoutEffect(() => {
    dispatchGetBanks({ ...DEFAULT_QUERY_GET_ALL });

    return () => {
      dispatchClearBanks();
    };
  }, []);

  return (
    <Select
      options={banks}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      {...rest}
    />
  );
};

BankSelect.propTypes = {
  dispatchGetBanks: PropTypes.func.isRequired,
  dispatchClearBanks: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  banks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

BankSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isLoading: false,
  isMulti: false,
  banks: [],
  isDisabled: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  banks: AccountingUnit.Bank.getIn(['all', 'content', 'content']).map(
    (bank) => ({
      value: bank.id,
      label: bank.name,
    }),
  ),
  isLoading: AccountingUnit.Bank.getIn(['all', 'loading']),
});

const mapDispatchToprops = {
  dispatchGetBanks: getBanks,
  dispatchClearBanks: clearBanks,
};

export default connect(mapStateToProps, mapDispatchToprops)(BankSelect);
